import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import { DeepCopyPipe } from '@quorum/common-pipes';
import { environment } from '@quorum/environments';
import { ResponseInterceptorOptions as ApiResponseHeaders } from '@quorum/models/xs-misc';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
export const QUORUM_API_BASE_OEM = new InjectionToken('QUORUM_API_BASE_OEM');
@Injectable()
export class OemIntegrationService {
  constructor(private http: HttpClient, @Inject(QUORUM_API_BASE_OEM) public quorumApiBase: string) {}

  getWithHeaders<T>(path: string, opts?: any): Observable<any> {
    path = stripSlash(path);

    if (opts) {
      return this.http
        .get(`${determineEnvironment()}${this.quorumApiBase}/${path}`, { ...opts, observe: 'response' })
        .pipe(
          map((res: any) => {
            const headers = new ApiResponseHeaders({});
            return { body: res.body, headers: headers };
          }),
          catchError((err: Response) => catcher(err, path))
        );
    } else {
      return this.http.get(`${determineEnvironment()}${this.quorumApiBase}/${path}`, { observe: 'response' }).pipe(
        map((res) => {
          const headers = new ApiResponseHeaders({});
          return { body: res.body, headers: headers };
        }),
        catchError((err: Response) => catcher(err, path))
      );
    }
  }

  getApiUrl() {
    return this.quorumApiBase;
  }

  get<T>(path: string, opts?: any): Observable<any> {
    path = stripSlash(path);
    if (opts) {
      return this.http.get(`https://${determineEnvironment()}${this.quorumApiBase}/${path}`, opts).pipe(
        map((res) => {
          return res;
        }),
        catchError((err: Response) => {
          return catcher(err, path);
        })
      );
    } else {
      return this.http.get(`https://${determineEnvironment()}${this.quorumApiBase}/${path}`).pipe(
        map((res) => res),
        catchError((err: Response) => catcher(err, path))
      );
    }
  }

  post<T>(path: string, body: any, opts?: any): Observable<any> {
    if (opts) {
      return this.http
        .post(
          `https://${determineEnvironment()}${this.quorumApiBase}/${path}`,
          body ? emptyStringsToNull(body) : undefined,
          opts
        )
        .pipe(
          map((res: any) => {
            if (opts.observe) return res.body;
            else return res;
          }),
          catchError((err) => catcher(err, path))
        );
    } else {
      return this.http
        .post(
          `https://${determineEnvironment()}${this.quorumApiBase}/${path}`,
          body ? emptyStringsToNull(body) : undefined
        )
        .pipe(
          map((res) => res),
          catchError((err) => catcher(err, path))
        );
    }
  }
}

function catcher(err: any, path: string): any {
  let body: any = null;
  switch (err.status) {
    case 403:
      return throwError({
        reason: `The requested operation is forbidden.`,
        error: err.error,
        statusCode: err.status,
        message: err.message,
      });
    case 404:
      return throwError({
        reason: `Data for /${path} could not be loaded at this time.`,
        error: err.error,
        statusCode: err.status,
        message: err.message,
      });
    case 500:
      return throwError({
        reason: `Internal server internal.`,
        error: err.error,
        statusCode: err.status,
        message: err.message,
      });
    case 503:
      body = err.error;
      return throwError({
        reason: body.error_description,
        statusCode: err.status,
        message: err.message,
      });
    default:
      return throwError({
        reason: `Unknown error loading /${path}.`,
        error: err.error,
        statusCode: err.status,
        message: err.message,
      });
  }
}

/**
 * Fix path if it has a leading slash.
 */
function stripSlash(path: string): string {
  return path.replace(/^\//, '');
}

function determineEnvironment(): string {
  switch (environment.environment) {
    case 'development':
      return 'development-oem-integration';
    case 'staging':
      return 'staging-oem-integration';
    case 'production':
      return 'oem-integration';
    default:
      return 'staging-oem-integration';
  }
}

function emptyStringsToNull(body: any) {
  const bodyCopy = new DeepCopyPipe().transform(body);
  Object.keys(bodyCopy).forEach((entry: any) => {
    if (bodyCopy[entry] === '') {
      bodyCopy[entry] = null;
    }
  });
  return bodyCopy;
}
